<template>
  <InfoModal
    id="MyModal"
    class="infoModalCrm"
    :show="showCrmModal"
    @update:show="closeCrmModal()"
  >
    <div class="contentModal open success modalCrm">
      <span
        class="material-icons closeOrder"
        id="closeModalX"
        @click="closeCrmModal()"
        >close</span
      >
      <h3>{{ $t("homePage.requestCrm.title") }}</h3>
      <p class="sub">{{ $t("homePage.requestCrm.sub") }}</p>
      <div class="mdl-grid">
        <div class="mdl-cell mdl-cell--12-col">
          <div class="label-container">
            <span class="labelTwo">{{ $t("homePage.requestCrm.text") }}</span>
          </div>
          <div class="cdl-textarea">
            <textarea
              maxlength="512"
              name="message"
              id="textarea"
              v-model="crmMessage"
            ></textarea>
          </div>
          <p class="error" v-if="crmError">
            {{ $t("homePage.requestCrm.error") }}
          </p>
        </div>
      </div>
      <div class="contentButton">
        <ActionButton
          id="btnModal"
          custom-class="cdlButtonGreen"
          :title="$t('homePage.requestCrm.btn')"
          :loading="crmSending"
          @click="sendCrmMessage()"
        >
          {{ $t("homePage.requestCrm.btn") }}
        </ActionButton>
        <br /><br />
        <div>
          <p class="deleteOrder" id="deleteOrder" @click="closeCrmModal()">
            {{ $t("homePage.requestCrm.link") }}
          </p>
        </div>
      </div>
    </div>
  </InfoModal>
</template>

<script setup>
import InfoModal from "@/components/Primitives/Modals/InfoModal.vue";
import ActionButton from "@/components/Primitives/Buttons/ActionButton.vue";
import { useCrmRequest } from "@/composables/dashboard/useCrmRequest";

const { showCrmModal, crmMessage, crmError, crmSending, closeCrmModal, sendCrmMessage } =
  useCrmRequest();
</script>

<style>
/* Neutralizza il contenitore di default di InfoModal per il CRM modal */
#MyModal.infoModalCrm .modal-content {
  width: 100%;
  min-width: 0;
  max-width: none;
  padding: 0;
  border-radius: 0;
  background: transparent;
}
</style>